export default {"src":"/_next/static/media/phone.3b252c5f.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};